/***************************************************************
6/9/2017
Alexander Self
Timesheet Edit
- Allows supervisors and managers to edit exisiting timesheets
***************************************************************/
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import EmployeeList from '../../employee_list';
import TimesheetEditForm from './timesheet_edit_form';
import TimesheetEditList from './timesheet_edit_list';
import TimesheetEditModal from './timesheet_edit_modal';
import { fetchTimesheetDatesToEdit, fetchTimesheetToEdit, removeWorkFromEditTimesheet,
 addWorkToEditTimesheet, prepareEditTS, submitEditTimesheet, fetchSubAccounts, fetchFieldsByLoc,
 fetchBlocksByField, removeHarvest, addHarvest, selectCostCenterByLocation,
 editWorkRecordInEditTimesheet, editWorkInEditTimesheet, selectHarvestToEdit,
 editHarvest } from '../../../actions';
import { AutoComplete } from '../../inputs';
import { mapEmployeeForAutoComplete, findEmployeeByName, onDummyComplete } from '../../../utils';

const TimesheetEdit = ({ user, employees, myEmployees, fields, blocks, costCenters, details,
  equipmentNo, equipmentTrailerNo, subAccounts, timesheet, subTimesheets, paycodes,
  timesheetDates, employeeSelected, submitter, removedWork, payPeriodStartDate, payPeriodEndDate,
  prevPPStartDate, prevPPEndDate, harvestTimesheet, removedHarvest, fetchTimesheetDatesToEdit,
  fetchTimesheetToEdit, removeWorkFromEditTimesheet, addWorkToEditTimesheet, prepareEditTS,
  submitEditTimesheet, fetchSubAccounts, fetchFieldsByLoc, fetchBlocksByField, removeHarvest,
  addHarvest, selectCostCenterByLocation, editWork, editWorkRecord, selectHarvestToEdit,
  editHarvest, harvestToEdit
 }) => {
  return (
    <div className="row">
      <blockquote>
        <span className="flow-text">Edit Timesheet {"\u00a0"}
            { employeeSelected.firstName ?
            <b>{employeeSelected.firstName} {employeeSelected.lastName}</b> :
              'Select an Employee' }
        </span>
      </blockquote>
      <div className="col s12 m12 l2 xl2">
        <AutoComplete id={'employee-edit-ts-list'} label={'Find Employee'}
          data={mapEmployeeForAutoComplete(employees)}
          onComplete={(val, id) => onDummyComplete(val, id)}
        />
        <button className="btn waves-light waves-effect"
          onClick={() => fetchTimesheetDatesToEdit(findEmployeeByName(document.getElementById('employee-edit-ts-list').value, employees), { payPeriodStartDate, payPeriodEndDate, prevPPStartDate, prevPPEndDate }, user)}>
          Fetch
        </button>
        <div className="emp-list">
          <div className="card">
            <EmployeeList employees={myEmployees} onClick={(e) => fetchTimesheetDatesToEdit(e, { payPeriodStartDate, payPeriodEndDate }, user)}
              icon={'add'} header={'Select Employee'} _class={'green'} isEditOrDelete={true}
            />
          </div>
        </div><br />
        <center>
          <a href="#edit-ts-modal" onClick={() => prepareEditTS(timesheet, subTimesheets, submitter, removedWork, harvestTimesheet, removedHarvest)}
            className="btn waves-light waves-effect blue">
            Prepare
          </a>
        </center>
        <TimesheetEditModal id={'edit-ts-modal'} subTimesheets={subTimesheets}
          timesheet={timesheet} employee={employeeSelected} submitTimesheet={submitEditTimesheet}
          removedWork={removedWork} harvestTimesheet={harvestTimesheet} removedHarvest={removedHarvest}
        />
      </div>
      <div className="col s12 m12 l10 xl10">
        <div className="row edit-timesheet-list">
          <div className="card">
            { timesheetDates.length > 0 ?
              <TimesheetEditList timesheets={timesheetDates} employee={employeeSelected} fetchTimesheetToEdit={fetchTimesheetToEdit} /> :
              'No Timesheets Available'
            }
          </div>
        </div>
        <div className="row">
          <TimesheetEditForm fields={fields} blocks={blocks} details={details} work={subTimesheets}
            costCenters={costCenters} paycodes={paycodes}
            removeWork={removeWorkFromEditTimesheet} addWork={addWorkToEditTimesheet}
            equipmentNo={equipmentNo} equipmentTrailerNo={equipmentTrailerNo} subAccounts={subAccounts}
            fetchSubAccounts={fetchSubAccounts} payPeriodStartDate={payPeriodStartDate} payPeriodEndDate={payPeriodEndDate}
            fetchFieldsByLoc={fetchFieldsByLoc} fetchBlocksByField={fetchBlocksByField} harvestTimesheet={harvestTimesheet}
            removeHarvest={removeHarvest} addHarvest={addHarvest} selectCostCenterByLocation={selectCostCenterByLocation}
            editWork={editWork} editWorkRecord={editWorkRecord} selectHarvestToEdit={selectHarvestToEdit}
            editHarvest={editHarvest} harvestToEdit={harvestToEdit}
          />
        </div>
      </div>
    </div>
  );
};

function mapStateToProps(state) {
  return {
    user: state.auth.user,
    employees: state.timesheet.employees,
    myEmployees: state.timesheet.myEmployees,
    fields: state.timesheet.fields,
    blocks: state.timesheet.blocks,
    details: state.timesheet.details.displaying,
    costCenters: state.timesheet.costCenters.displaying,
    equipmentNo: state.equipment.equipmentNo,
    equipmentTrailerNo: state.equipment.equipmentTrailerNo,
    paycodes: state.timesheet.paycodes,
    subAccounts: state.timesheet.subAccounts,
    submitter: state.auth.user.guid,
    timesheetDates: state.timesheet.edit.timesheetDates,
    employeeSelected: state.timesheet.edit.employee,
    subTimesheets: state.timesheet.edit.ts.subTimesheets,
    timesheet: state.timesheet.edit.ts.timesheet,
    removedWork: state.timesheet.edit.ts.removedWork,
    harvestTimesheet: state.timesheet.edit.ts.harvestTimesheet,
    removedHarvest: state.timesheet.edit.ts.removedHarvest,
    payPeriodStartDate: state.misc.payPeriod.startDate,
    payPeriodEndDate: state.misc.payPeriod.endDate,
    prevPPStartDate: state.misc.prevPP.startDate,
    prevPPEndDate: state.misc.prevPP.endDate,
    harvestToEdit: state.timesheet.edit.ts.editHarvest
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchTimesheetDatesToEdit,
    fetchTimesheetToEdit,
    removeWorkFromEditTimesheet,
    addWorkToEditTimesheet,
    prepareEditTS,
    submitEditTimesheet,
    fetchSubAccounts,
    fetchFieldsByLoc,
    fetchBlocksByField,
    removeHarvest,
    addHarvest,
    selectCostCenterByLocation,
    editWorkRecord: editWorkRecordInEditTimesheet,
    editWork: editWorkInEditTimesheet,
    selectHarvestToEdit,
    editHarvest
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(TimesheetEdit);


/* END */



// WEBPACK FOOTER //
// ./src/components/timesheets/edit/timesheet_edit.js